import { validatePhone, isValidEmail } from "../../utils/validation";

const getValidationError = (type, value, validations = {}) => {
  if (type === "phone") {
    const { success, message } = validatePhone(value);
    if (value && !success) {
      return message;
    }
  }

  if (type === "email") {
    if (value && !isValidEmail(value)) {
      return "El correo electrónico no es válido";
    }
  }

  return null;
};

export const FlexInputText = ({ 
  id, 
  label, 
  placeholder, 
  required = false, 
  type = "text", 
  rows = "1",
  value, 
  onChange,
  rootClass = "",
  className = "",
  register = () => {},
  error = null,
  validations = {},
  inputError = false,
  inputMessage = '',
  maxLength,
}) => {

  const validationError = getValidationError(type, value, validations);

  const handleChange = (e) => {
    onChange(e);
  }
  const renderInput = () => {
    const baseClass = "border-gray-300 focus:border-[#18446b] w-full transtion duration-150 ease-in-out text-sm disabled:cursor-default disabled:bg-gray-200 disabled:border-gray-200";
    const finalClass = className || baseClass;
    
    switch(type) {
      case 'phone':
        return <input
          id={id}
          {...register(id, { required: required, ...validations })}
          required={required}
          type="text"
          placeholder={placeholder}
          className={finalClass}
          value={value}
          onChange={handleChange}
          maxLength={maxLength || 10}
        />
      case 'textarea':
        return <textarea
          id={id}
          required={required}
          {...register(id, { required: required, ...validations })}
          type="text"
          rows={rows}
          placeholder={placeholder}
          className={finalClass}
          value={value}
          onChange={handleChange}
          maxLength={maxLength}
        />
      case 'email':
      case 'text':
      default:
        return <input
          id={id}
          {...register(id, { required: required, ...validations })}
          required={required}
          type={type}
          placeholder={placeholder}
          className={finalClass}
          value={value}
          onChange={handleChange}
          maxLength={maxLength}
        />
    }
  }

  const errorMessage = error?.message || validationError || (inputError && inputMessage);

  return (
    <div className={`w-full ${rootClass}`}>
      <div className="mb-6">
        <label
          htmlFor={id}
          className={`text-md mt-6 disabled:text-gray-400 ${errorMessage ? "text-red-500" : "text-dark"}`}
        >
          {label}
        </label>
        { renderInput() }
        { errorMessage && (
          <p className="text-sm text-red-500 mt-1">{errorMessage}</p>
        )}
      </div>
    </div>
  );
}